import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "b-profile-page" }
const _hoisted_2 = {
  ref: "leftBar",
  class: "b-profile-page__left-bar"
}
const _hoisted_3 = { class: "b-profile-page__left-bar__inner" }
const _hoisted_4 = { class: "b-profile-page__inner" }
const _hoisted_5 = { class: "b-profile-page__nav--mob__button" }
const _hoisted_6 = {
  key: 0,
  class: "b-profile-page__nav"
}
const _hoisted_7 = { class: "b-profile-page__route-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftBarMenu = _resolveComponent("LeftBarMenu")!
  const _component_FwBurgerIcon = _resolveComponent("FwBurgerIcon")!
  const _component_FwIcon = _resolveComponent("FwIcon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ChooseSiteLang = _resolveComponent("ChooseSiteLang")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_LeftBarMenu)
      ])
    ], 512),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_FwBurgerIcon, {
          class: "b-calendar-page__burger",
          size: 24,
          isActive: _ctx.isMenuOpen,
          color: _ctx.isMenuOpen ? "#ffffff" : "#213F6B",
          onToggle: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isMenuOpen = !_ctx.isMenuOpen))
        }, null, 8, ["isActive", "color"])
      ]),
      (_ctx.isMenuOpen && _ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profileNavItems, (item) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: item.link,
                to: item.link,
                class: "b-profile-page__nav__item",
                onClick: _ctx.onResize
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_FwIcon, {
                    class: "h-mr-15",
                    icon: item.icon,
                    original: true,
                    size: "20"
                  }, null, 8, ["icon"]),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(item.text)), 1)
                ]),
                _: 2
              }, 1032, ["to", "onClick"]))
            }), 128)),
            _createVNode(_component_ChooseSiteLang, {
              class: "h-ml-20",
              onSetLang: _ctx.setStorageLocale
            }, null, 8, ["onSetLang"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}